"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Erc4907EventType = void 0;
var Erc4907EventType;
(function (Erc4907EventType) {
    Erc4907EventType["UpdateUser"] = "UpdateUser";
})(Erc4907EventType || (exports.Erc4907EventType = Erc4907EventType = {}));
//# sourceMappingURL=erc4907.js.map